import { Component, computed, inject, input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TableSelectionService } from '../../services/table-selection.service';

@Component({
  selector: 'table-datatable-header-checkbox',
  templateUrl: './datatable-header-checkbox.component.html',
  styleUrls: ['./datatable-header-checkbox.component.scss'],
  imports: [MatCheckboxModule],
})
export class DatatableHeaderCheckboxComponent {
  ids = input<any[]>();

  private tableSelectionService = inject(TableSelectionService);

  onCheckboxToggle({ checked }: { checked: boolean }) {
    const ids = this.ids();
    if (checked) this.tableSelectionService.selectMultiple(ids);
    else this.tableSelectionService.deselectAll();
  }

  isSelected = computed(() => {
    const selection = this.tableSelectionService.selectionSignal();
    return this.ids()?.every((id) => selection.includes(id));
  });

  isIndeterminate = computed(() => {
    const selection = this.tableSelectionService.selectionSignal();
    return !this.isSelected() && this.ids()?.some((id) => selection.includes(id));
  });
}
